import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

/**
 * Set the isAccentColorUpdate bit in the copilot theme store
 * @param isUpdating - boolean indicating whether the copilot theme is updating accent color
 */
const setIsAccentColorUpdateMutator: (isUpdating: boolean) => void = mutatorAction(
    'setIsAccentColorUpdateMutator',
    (isUpdating: boolean): void => {
        getStore().isAccentColorUpdate = isUpdating;
    }
);
export default setIsAccentColorUpdateMutator;
